import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import CalculatorTwoToneSvg from "@ant-design/icons-svg/es/asn/CalculatorTwoTone";
import AntdIcon from "../components/AntdIcon";
var CalculatorTwoTone = function CalculatorTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: CalculatorTwoToneSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  CalculatorTwoTone.displayName = 'CalculatorTwoTone';
}
export default /*#__PURE__*/React.forwardRef(CalculatorTwoTone);